/**
 * User Portal BFF
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { SortExpression } from './sort-expression';
import { WorkerStatuses } from './worker-statuses';
import { DateTimePeriod } from './date-time-period';


export interface SearchWorkersRequest { 
    skip?: number;
    take?: number;
    includeTotalCount?: boolean | null;
    sortExpressions?: Array<SortExpression> | null;
    accountId?: string | null;
    miningProductId: number;
    statusIds?: Array<WorkerStatuses> | null;
    groupIds?: Array<string> | null;
    workerNameKeyword?: string | null;
    upTimePeriod?: DateTimePeriod;
}

